import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/shared/Layout/Layout';
import Loading from '../../components/shared/Loading/Loading';
import Button from '../../components/shared/Button/Button';
import { SalesContainer, PageHead, Panel, Notice } from './Sales.styles';

// Estados previos a mostrar una pantalla de venta (cargando, sin permiso, sin conexión).
// Devuelve null cuando el acceso está en orden y la pantalla puede dibujarse.
const SalesGate = ({ access }) => {
  const { status, headerType, staffAuth } = access;
  if (status === 'ok') return null;

  if (status === 'loading') {
    return (
      <Layout headerType={headerType}>
        <Loading text="Verificando tu acceso..." />
      </Layout>
    );
  }

  if (status === 'redirect') return <Loading text="Cargando..." />;

  if (status === 'connection-error') {
    return (
      <Layout headerType={headerType}>
        <SalesContainer>
          <Notice $error role="alert">
            <strong>No pudimos verificar tu acceso.</strong> {staffAuth.connectionError}
          </Notice>
          <Button onClick={() => staffAuth.refresh().catch(() => {})}>Reintentar</Button>
        </SalesContainer>
      </Layout>
    );
  }

  // denied: staff con rol `scanner`
  return (
    <Layout headerType={headerType}>
      <SalesContainer>
        <PageHead>
          <h1>Ventas en persona</h1>
        </PageHead>
        <Panel>
          <h2>Tu rol no puede vender</h2>
          <p style={{ color: 'var(--text-secondary)', marginBottom: 16 }}>
            Tu acceso es de <strong>escáner</strong>: puedes validar QRs pero no crear ventas.
            Si te corresponde vender, pídele a tu empresa que te cambie a <strong>operador</strong>.
          </p>
          <Link to="/staff/scanner"><Button>Ir al escáner</Button></Link>
        </Panel>
      </SalesContainer>
    </Layout>
  );
};

export default SalesGate;
